var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"ui-list__item",style:({
        '--ui-list-item-label-width': _setup.props.labelWidth,
        '--ui-list-item-value-width': _setup.props.valueWidth,
        '--ui-list-item-gap': _setup.spaceFormat(_setup.props.space),
    })},[_c('span',{staticClass:"ui-list__label"},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_setup.props.label)+" ")]})],2),_c('span',{staticClass:"ui-list__value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }